import http from '@amit/composables/src/useHttp';
import { useApi } from '@amit/composables';
import { formatDistanceToNow } from 'date-fns';
import { he } from 'date-fns/locale';

export const checkIframeEmbed = (url: string) => {
  return useApi(http.post(`courses/iframe?url=${url}`));
};

export const timeAgo = (date: string | Date) => {
  return formatDistanceToNow(new Date(date), { addSuffix: false, locale: he });
};
